var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 104,
    viewBox: "0 0 115 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.72854V41.3952M4.5 41.3952H36.3022M4.5 41.3952L29.0937 18.3841C36.4131 11.1083 45.9089 6.3981 56.1504 4.96332C66.392 3.52854 76.8244 5.44686 85.8758 10.4292C94.9272 15.4116 102.107 23.1881 106.334 32.5871C110.561 41.9861 111.606 52.4983 109.311 62.5398C107.016 72.5814 101.506 81.6083 93.6106 88.2605C85.7154 94.9127 75.8629 98.8298 65.5376 99.4215C55.2123 100.013 44.9735 97.2476 36.364 91.5413C27.7545 85.835 21.2407 77.4971 17.8039 67.784",
    stroke: "#413C35",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.c873a52e4fb9de25675e4c994adf8bfb.svg";
export { ForwardRef as ReactComponent };